import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';
import { UtilisateurService } from '../../services/utilisateur.service';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { FeatureFlag } from 'src/app/bo/featureFlag';

@Component({
  selector: 'app-nav-bar-left',
  templateUrl: './nav-bar-left.component.html',
  styleUrls: ['./nav-bar-left.component.scss'],
  standalone: false
})
export class NavBarLeftComponent implements OnInit {
  utilisateurAdmin = signal<boolean>(false);
  utilisateurRespReg = signal<boolean>(false);
  utilisateurRespSite = signal<boolean>(false);
  referentielOuvert = signal<boolean>(false);
  versionNumber = signal<string>(environment.version);
  enableSetupOrganization = signal<boolean>(false);
  protected tenantName = signal<string>("");

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public utilService: UtilisateurService,
    private readonly http: HttpService,
    public router: Router,
    public fonctionsService: FonctionsService,
    private readonly utilisateurService: UtilisateurService,
    private readonly keycloakUtilisateurService: KeycloakUtilisateurService,

   ) {
    // Initialisation
    // _TODO


    

  //   this.fn_getCurrentRole(() => {
  //     // Access this.currentRole within the callback function
  //     console.log("currentRole : ", JSON.stringify(this.currentRole));
    
  //   // this.utilisateurAdmin = utilService.userRole == ExploreRole.Administrateur;
  //   if(this.currentRole == ExploreRole.ADMIN)
  //   {
  //     this.utilisateurAdmin = true;
  //     console.log("EST UN ADMINISTRATEUR");
  //   }

  //   // this.utilisateurRespReg = utilService.userRole == ExploreRole.ResponsableRegion;
  //   if(this.currentRole == ExploreRole.RESP_REGION)
  //   {
  //     this.utilisateurRespReg = true;
  //     console.log("EST UN RESPONSABLE DE REGION");
  //   }

  //   // this.utilisateurRespSite = utilService.userRole == ExploreRole.ResponsableSite;
  //   if(this.currentRole == ExploreRole.RESP_SITE)
  //   {
  //     this.utilisateurRespSite = true;
  //     console.log("EST UN RESPONSABLE DE SITE");
  //   }
  // });
  //   // Abonnement pour les cas : connexion, déconnexion de a/connexion de b...
  //   utilService.utilisateur$.subscribe(() => {
  //     // _TODO
  //   // this.utilisateurAdmin = utilService.userRole == ExploreRole.Administrateur;
  //   if(this.currentRole == ExploreRole.ADMIN)
  //   {
  //     this.utilisateurAdmin = true;
  //     console.log("EST UN ADMINISTRATEUR");
  //   }

  //   // this.utilisateurRespReg = utilService.userRole == ExploreRole.ResponsableRegion;
  //   if(this.currentRole == ExploreRole.RESP_REGION)
  //   {
  //     this.utilisateurRespReg = true;
  //     console.log("EST UN RESPONSABLE DE REGION");
  //   }

  //   // this.utilisateurRespSite = utilService.userRole == ExploreRole.ResponsableSite;
  //   if(this.currentRole == ExploreRole.RESP_SITE)
  //   {
  //     this.utilisateurRespSite = true;
  //     console.log("EST UN RESPONSABLE DE SITE");
  //   }
  //   });

  }

  ngOnInit() {
    this.referentielOuvert.set(this.router.url.includes('users') || this.router.url.includes('regions') || this.router.url.includes('region') || this.router.url.includes('sites') || this.router.url.includes('site-setup')
      || this.router.url.includes('operators') || this.router.url.includes('workflows') || this.router.url.includes('config-analysis') || this.router.url.includes('setup-organization'));
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.referentielOuvert.set(this.router.url.includes('users') || this.router.url.includes('regions') || this.router.url.includes('region') || this.router.url.includes('sites') || this.router.url.includes('site-setup')
      || this.router.url.includes('operators') || this.router.url.includes('workflows') || this.router.url.includes('config-analysis') || this.router.url.includes('area-dashboard') || this.router.url.includes('user-dashboard') || this.router.url.includes('setup-organization'));
  });
    

    this.http.get<FeatureFlag[]>("FeatureFlag").subscribe({
      next: (flags) => {
        const setupOrgFlag = flags.find(f => f.featureName === 'show-setup-organization');
        this.enableSetupOrganization.set(setupOrgFlag?.isEnabled ?? false);
      },
      error: (error) => {
        console.error('Failed to load feature flags', error);
        this.enableSetupOrganization.set(false);
      }
    });
  }


  inverserReferentielOuvert() {
    
      this.referentielOuvert.set(!this.referentielOuvert());
  }

  // fn_getCurrentRole(callback: () => void) {
  //   this.keycloakUserService.getCurrentKeycloakRoleUtilisateur().subscribe(
  //     result => {
  //       this.keycloakRoleUtilisateur = result;
  //       this.k_role = result.name;
  //       this.currentRole = this.k_role;
  //       callback();
  //       console.log(result);
  //     },
  //     error => {
  //       console.error('Failed to load users role', error);
  //       this.fonctionsService.launch_toast(false);
  //     }
  //   );
  // }
}
